import { createTestAttribute } from '@celito.clients/utils';
import { mergeClasses, Text } from '@fluentui/react-components';

import { padLeftWithZero } from '../../../utils/helper';
import { wizardTypesStyles } from './types.styles';

const InactiveTypeSectionView: React.FC<{
  label: string;
  onClick: () => void;
  index: number;
}> = ({ label, onClick, index }) => {
  const styles = wizardTypesStyles();

  return (
    <div
      data-testid="inactive-icon-container"
      className={mergeClasses(styles.section, styles.inactiveType)}
      onClick={onClick}
    >
      <Text
        data-testid={`label-inactive-icon-${createTestAttribute(label)}`}
        className={styles.text}
      >
        {padLeftWithZero(index)} {label}
      </Text>
    </div>
  );
};

export default InactiveTypeSectionView;
